export const HiddenSortingMachingUserFields = [
  '_id',
  '_class',
  'mentorID',
  'menteeID',
  'timeframeID',
  'username',
  'roles',
  'isOnline',
  'ios_sub',
  'emailConfirmed',
  'matches',
  'foreignLanguages',
  'nativeLanguage',
  'preferedMentorsIDs',
  'read_terms_of_use',
  'emailRepeat',
  'minSemesterPrerequisite',
  'extraSubjectSonstiges',
  'privacyPolicy',
];
